<script module>
  import { writable } from 'svelte/store';

  export const isSearchDropdownOpen = writable(false);
</script>

<script lang="ts">import MagnifyingGlass from '../../../Search/MagnifyingGlass.svelte';
import SearchBar from '../../../Search/SearchBar.svelte';
import { onTouchOrClick } from '../../../../js-v2/onTouchOrClick';
import { hoverWithDelay } from '../../../../js-v2/hoverWithDelay';
let dropdownHeight = $state();
let searchInputEl = $state();
let applyHiddenStatusTimeout = $state();
let applyHiddenClass = $state(true);
const TOGGLE_ANIMATION_DURATION_MS = 200;
function open() {
    // Make sure hidden is not applied nor will be applied.
    window.clearTimeout(applyHiddenStatusTimeout);
    applyHiddenClass = false;
    $isSearchDropdownOpen = true;
    window.setTimeout(() => searchInputEl.focus(), TOGGLE_ANIMATION_DURATION_MS);
}
function close() {
    $isSearchDropdownOpen = false;
    // Restart the timeout to apply the hidden class.
    window.clearTimeout(applyHiddenStatusTimeout);
    applyHiddenStatusTimeout = window.setTimeout(() => (applyHiddenClass = true), TOGGLE_ANIMATION_DURATION_MS);
}
function toggle() {
    $isSearchDropdownOpen ? close() : open();
}
</script>

<div class="Dropdown" use:hoverWithDelay={[open, close, 100, 300]}>
  <button use:onTouchOrClick={toggle}>
    <MagnifyingGlass />
  </button>

  <div
    class="DropdownContent"
    class:isOpen={$isSearchDropdownOpen}
    style:--animation-duration={`${TOGGLE_ANIMATION_DURATION_MS}ms`}
    style:--dropdown-height={`${dropdownHeight}px`}
  >
    <div bind:clientHeight={dropdownHeight} class="DropdownContentInner" class:hidden={applyHiddenClass}>
      <SearchBar bind:inputEl={searchInputEl} on:blur={() => close()} />
    </div>
  </div>
</div>

<style>@keyframes fade-in-slide-from-top {
  from {
    opacity: 0;
    transform: translateX(0) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes fade-in-slide-from-left {
  from {
    opacity: 0;
    transform: translateX(-4px) translateY(0);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes slide-down {
  from {
    transform: translateY(-50%);
  }
  to {
    transform: translateY(0);
  }
}
/**
We use rem units for media queries to promote accessible layouts. By utilizing rem units, the computed values in media queries are determined by the user's browser-defined font size rather than our global 'font-size: 62.5%' reset. This approach ensures that our design adapts to individual user settings, enhancing accessibility. 
*/
button {
  --letter-spacing: var(--text-variant-100-letter-spacing);
  --line-height: var(--text-variant-100-line-height);
  --font-size: var(--text-variant-100-font-size);
  --font-weight: var(--text-variant-100-font-weight);
  --font-family: var(--text-font-family);
  --max-width: var(--text-variant-100-max-width);
  color: var(--color-text);
  font-family: var(--font-family);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  letter-spacing: var(--letter-spacing);
  line-height: var(--line-height);
  max-width: var(--max-width);
  cursor: pointer;
  appearance: none;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  display: inline-block;
  width: auto;
  height: auto;
  min-height: 0;
  max-height: none;
  min-width: 0;
  max-width: none;
  margin: 0;
  padding: 10px 10px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--color-text, var(--color-neutral-000, #000000));
  letter-spacing: normal;
  text-align: center;
  vertical-align: middle;
  text-decoration: none;
  white-space: nowrap;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: transparent;
  background-color: transparent;
  border: none;
  cursor: pointer;
  line-height: 1;
  padding: 18px 10px;
}
button:focus-visible:not(:active) {
  outline: var(--accessibility-focus-outline-width) var(--accessibility-focus-outline-style, solid) var(--accessibility-focus-outline-color);
  border-radius: var(--accessibility-focus-outline-border-radius);
  outline-offset: var(--accessibility-focus-outline-offset);
}
button:focus {
  background: transparent;
  outline: none;
}
button:hover {
  background: transparent;
}

.DropdownContent {
  padding-left: 0px;
  padding-right: 0px;
  position: absolute;
  overflow: hidden;
  top: var(--desktop-nav-height);
  left: 0;
  max-height: 0;
  width: 100%;
  transition: max-height var(--animation-duration) cubic-bezier(0.4, 0, 0.6, 1);
  background: var(--color-background, var(--color-neutral-000, #000000));
}
@media (min-width: 105rem) {
  .DropdownContent {
    --nav-outer-gutter-base: calc(var(--space-10) / 2);
    --nav-outer-gutter: max(var(--nav-outer-gutter-base), var(--dynamic-gutter));
    padding-left: calc(0px + var(--nav-outer-gutter)) !important;
    padding-right: calc(0px + var(--nav-outer-gutter)) !important;
  }
}
.DropdownContent.isOpen {
  max-height: var(--dropdown-height);
}</style>
